<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'GROUP_TRAINING_MANAGEMENT.PAGE_GROUP_TRAINING_MANAGEMENT' | translate }}
    <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">groups</mat-icon>
  </p>
  <div class="hidden sm:block overflow-x-auto">
    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }

    @if (!isLoading) {
      <div>
        <div class="flex items-center justify-between mb-4">
          <div class="inline-flex rounded-md shadow-sm" role="group">
            <button type="button"
              [ngClass]="{'bg-red-600 text-white': filter === 'complete', 'bg-gray-200 text-gray-700': filter !== 'complete'}"
              (click)="setFilter('complete')"
              class="px-4 py-2 text-sm font-medium rounded-l-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
              {{ 'GROUP_TRAINING_MANAGEMENT.TOOGLE_COMPLETE' | translate }}
            </button>
            <button type="button"
              [ngClass]="{'bg-red-600 text-white': filter === 'plannifier', 'bg-gray-200 text-gray-700': filter !== 'plannifier'}"
              (click)="setFilter('plannifier')"
              class="px-4 py-2 text-sm font-medium rounded-r-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
              {{ 'GROUP_TRAINING_MANAGEMENT.TOOGLE_PLANNIFIER' | translate }}
            </button>
          </div>
        </div>
        @if (isLoading) {
          <div class="flex justify-center items-center h-64">
            <mat-spinner color="accent"></mat-spinner>
          </div>
        }
        @if (!isLoading) {
          <div class="flex justify-end items-center mb-4 gap-2">
            <button [matMenuTriggerFor]="exportMenu" [disabled]="isLoading || !dataSource.data.length"
              class="btn-primary-novo">
              {{ 'GROUP_TRAINING_MANAGEMENT.EXPORT' | translate }}
              <mat-icon>expand_more</mat-icon>
            </button>
            <mat-menu #exportMenu="matMenu" panelClass="export-menu-styling">
              <button mat-menu-item (click)="exporterVersExcel()">
                <mat-icon>table_view</mat-icon>
                <span>{{ 'GROUP_TRAINING_MANAGEMENT.EXPORT_EXCEL' | translate }}</span>
              </button>
              <button mat-menu-item (click)="exporterVersPdf()">
                <mat-icon>picture_as_pdf</mat-icon>
                <span>{{ 'GROUP_TRAINING_MANAGEMENT.EXPORT_PDF' | translate }}</span>
              </button>
            </mat-menu>
            <button (click)="openCreateGroupTrainingDialog()" class="btn-primary-novo">{{ 'GROUP_TRAINING_MANAGEMENT.CREATE_GROUP_TRAINING' | translate }}</button>
          </div>
          <div class="flex justify-end items-center mb-4 gap-3">
            <mat-select placeholder="{{ 'GROUP_TRAINING_MANAGEMENT.FILTRE_CONTENUS' | translate }}" multiple
              class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320" panelHeight="100"
              [(ngModel)]="selectionTitreContenu" (selectionChange)="filtre()">
              <mat-option>
                <ngx-mat-select-search [formControl]="titreFilterCtrl"
                  [placeholderLabel]="'GROUP_TRAINING_MANAGEMENT.SEARCH' | translate"
                  [noEntriesFoundLabel]="'GROUP_TRAINING_MANAGEMENT.NO_RESULTS' | translate">
                </ngx-mat-select-search>
              </mat-option>
              @for (titre of filteredTitres | async; track titre) {
                <mat-option [value]="titre"><span [innerHtml]="titre">{{ titre
                }}</span></mat-option>
              }
            </mat-select>
            <mat-select class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320"
              panelHeight="100" placeholder="{{ 'GROUP_TRAINING_MANAGEMENT.FILTRE_DATE_ACCES' | translate }}"
              [(ngModel)]="selectionDateAcces" one (selectionChange)="filtre()">
              <mat-option class="w-48 h-10" [value]="'today'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.TODAY' |
              translate}}</span></mat-option>
              <mat-option class="w-48 h-10" [value]="'yesterday'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.YESTERDAY' |
              translate}}</span></mat-option>
              <mat-option class="w-48 h-10" [value]="'week'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.WEEK' |
              translate}}</span></mat-option>
              <mat-option class="w-48 h-10" [value]="'lastweek'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.LASTWEEK' |
              translate}}</span></mat-option>
              <mat-option class="w-48 h-10" [value]="'last30days'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.LAST30DAYS' |
              translate}}</span></mat-option>
              <mat-option class="w-48 h-10" [value]="'lastmonth'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.LASTMONTH' |
              translate}}</span></mat-option>
              <mat-option class="w-48 h-10" [value]="'year'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.YEAR' |
              translate}}</span></mat-option>
              <mat-option class="w-48 h-10" [value]="'lastyear'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.LASTYEAR' |
              translate}}</span></mat-option>
              <mat-option class="w-48 h-10" [value]="'alldate'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.ALLDATE' |
              translate}}</span></mat-option>
              <mat-option class="w-48 h-10" [value]="'custom'"><span>{{ 'GROUP_TRAINING_MANAGEMENT.CUSTOM_RANGE_DATE' | translate
              }}</span></mat-option>
            </mat-select>
            @if (selectionDateAcces === 'custom') {
              <div
                class="custom-date-range flex items-center gap-2 w-1/5 h-8 max-w-[235px] border border-gray-300 rounded-md px-3 py-1">
                <mat-date-range-input [rangePicker]="picker" class="flex-1">
                  <input matStartDate (dateChange)="filtre()" [(ngModel)]="dateDebut" />
                  <input matEndDate (dateChange)="filtre()" [(ngModel)]="dateFin" />
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </div>
            }
            <div class="flex flex-col gap-2">
              <div class="flex items-center gap-2">
                <input type="text" [(ngModel)]="textRechercher" (ngModelChange)="filtre()"
                  placeholder="{{ 'GROUP_TRAINING_MANAGEMENT.SEARCH' | translate }}..."
                  class="h-8 w-46 rounded-md border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
                  <button mat-icon-button (click)="reinitialiserFiltre()"
                    class="h-5 w-8 bg-white-200 text-white-600 rounded">
                    <mat-icon>restore</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="w-full overflow-x-auto">
              <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo" (matSortChange)="sortDataChange($event)">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{ 'GROUP_TRAINING_MANAGEMENT.FORMATIONID' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">{{element.id | tiret}} </td>
                </ng-container>
                <ng-container matColumnDef="titre">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{ 'GROUP_TRAINING_MANAGEMENT.TITRE_FORMATION' | translate
                  }}</th>
                  <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{element.titre | tiret  }} </td>
                </ng-container>
                <ng-container matColumnDef="titreContenu">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{ 'GROUP_TRAINING_MANAGEMENT.TITRE_CONTENU' | translate
                  }}</th>
                  <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{ getLocalizedContent(element.packageId).titre | tiret  }} </td>
                </ng-container>
                <ng-container matColumnDef="emplacement">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{ 'GROUP_TRAINING_MANAGEMENT.EMPLACEMENT' | translate
                  }}</th>
                  <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{ element.emplacement | tiret }} </td>
                </ng-container>
                <ng-container matColumnDef="datePrevue">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{ 'GROUP_TRAINING_MANAGEMENT.DATE_PREVUE' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{ moment(element.dateHeurePrevue).locale('fr').format('YYYY-MM-DD HH:mm') | tiret }} </td>
                </ng-container>
                @if (estPageComplete === true) {
                  <ng-container matColumnDef="dateCompletee">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{ 'GROUP_TRAINING_MANAGEMENT.DATE_COMPLETE' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{ moment(element.dateCompletee).locale('fr').format('YYYY-MM-DD HH:mm') | tiret }} </td>
                  </ng-container>
                }
                <ng-container matColumnDef="commentaire">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2 max-w-[450px]"> {{ 'GROUP_TRAINING_MANAGEMENT.COMMENTAIRE' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="hidden md:table-cell px-4 py-2 border-b max-w-[450px]"> {{ element.commentaire | tiret}} </td>
                </ng-container>
                <ng-container matColumnDef="prenomNomAjoutUtilisateurPar">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2"> {{ 'GROUP_TRAINING_MANAGEMENT.CREER_PAR' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="hidden md:table-celll px-4 py-2 border-b"> {{ element.prenomNomAjoutUtilisateurPar | tiret}} </td>
                </ng-container>
                <ng-container matColumnDef="superviseurs">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{ 'GROUP_TRAINING_MANAGEMENT.SUPERVISEUR' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">
                    @for (superviseur of element.utilisateurs; track superviseur) {
                      <div>
                        @if (superviseur.estResponsableFormation == true) {
                          <span class="inline-block whitespace-nowrap text-sm rounded-full border border-gray-200 px-2 py-0.5">{{superviseur.prenom}} {{superviseur.nom}}</span>
                        }
                      </div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="nombreParticipants">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{ 'GROUP_TRAINING_MANAGEMENT.NB_PARTICIPANTS' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b text-center">
                    <div>{{ nombreParticipants(element.id) | tiret }}<mat-icon (click)="showParticipants(element)" class="material-icons-outlined text-black-500 hover:text-red-700 transform scale-90 sm:scale-100 icon-small"> visibility </mat-icon></div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index" class="px-2 py-1 text-center">
                    @if (element.dateCompletee === null) {
                      <div class="menu-container">
                        <button (click)="toggleMenu(i)"
                          class="bg-grey-500 hover:bg-grey-700 font-bold py-2 px-4 border-none hover:text-red-700 transform scale-90 sm:scale-100">
                          <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                        </button>
                        @if (element.isMenuOpen) {
                          <div
                            class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                            <div class="py-1" role="menu"
                              aria-orientation="vertical" aria-labelledby="options-menu">
                              <a href="javascript:void(0)"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                role="menuitem" (click)="editTrainning(element)">
                                {{ 'GROUP_TRAINING_MANAGEMENT.EDIT' | translate }}
                              </a>
                            </div>
                            <div class="py-1" role="menu"
                              aria-orientation="vertical" aria-labelledby="options-menu">
                              <a href="javascript:void(0)"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                role="menuitem" (click)="withdrawTrainning(element.id)">
                                {{ 'GROUP_TRAINING_MANAGEMENT.DELETE' | translate }}
                              </a>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
              </table>
              @if (dataSource.filteredData.length === 0) {
                <div class="text-center mt-2 text-gray-500">
                  {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
                </div>
              }
              <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
                (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
              </mat-paginator>
            </div>
          }
        </div>
      }
    </div>
  </div>
